<template>
  <div class="post type-post hentry">
    <h2>
      <router-link
        to="/2011/01/giminystes-rysiu-reiksme-teisiniuose-reikaluose/"
        >Giminystės ryšių reikšmė teisiniuose reikaluose</router-link
      >
    </h2>
    <div class="comm_date">
      <span class="month">Sausio</span><span class="date_nr">6</span>
    </div>
    <div class="entry">
      <p>
        Tema apie giminystę yra pakankamai svarbi, nes, apie tai nežinant, gali
        kilti įvairių nesusipratimų.
      </p>
      <p>
        Didysis lietuvių kalbos žodynas rašo, kad „giminė – kelios kartos
        žmonių, turinčių bendrus protėvius“, o giminystė – tai „buvimas gimine,
        giminiškumas“. Lietuvoje, vadinamoje brolelių ir „švogerėlių“ žeme, ypač
        – jos teisėje, giminystė yra svarbi sąlyga teisėms ir pareigoms,
        apribojimams, įvairioms sąlygoms ir aplinkybėms atsirasti. Su giminystės
        sąvoka susiduriame įvairiuose civiliniuose teisiniuose santykiuose,
        valstybės tarnybos, baudžiamojo proceso ir kituose teisiniuose
        reikaluose. Giminystės ryšiai itin aktualūs paveldėjimo ir šeimos
        teisiniuose santykiuose. Pavyzdžiui, paveldint pagal įstatymą Lietuvoje
        egzistuoja šešios įpėdinių eilės LR Civilinio kodekso 5.11 straipsnyje,
        nustatytos vien tik pagal kraujo giminystės laipsnį.
      </p>
      <p>
        LR CK 3.130 str. sako, kad&nbsp;<strong
          >giminystė – yra kraujo ryšys tarp asmenų, kilusių vienas iš kito arba
          iš bendro protėvio</strong
        >.
      </p>
      <p>
        Civilinėje teisėje numatytos&nbsp;<strong
          >tiesioji ir šoninė giminystės linijos</strong
        >. Tiesioji giminystės linija yra tarp protėvio ir palikuonių
        (proseneliai, seneliai, tėvai, vaikai, vaikaičiai, provaikaičiai ir t.
        t.). Giminystė, einanti iš palikuonio į protėvį, yra&nbsp;<strong
          >tiesioji aukštutinė</strong
        >
        giminystės linija (vaikaičiai, vaikai, tėvai, seneliai ir t. t.).
        Giminystė, einanti iš protėvio į palikuonį, yra&nbsp;<strong
          >tiesioji žemutinė</strong
        >
        giminystės linija (seneliai, tėvai, vaikai, vaikaičiai ir t. t.).
        Giminystė tarp asmenų, kilusių iš bendro protėvio, yra&nbsp;<strong
          >šoninė giminystės linija</strong
        >
        (broliai ir seserys, pusbroliai ir pusseserės, dėdės arba tetos ir
        sūnėnai arba dukterėčios ir t. t.).
      </p>
      <p>
        Giminystės laipsnis – tai skaičius gimimų, kurie sieja giminaičius,
        išskyrus bendro protėvio (protėvių) gimimą. Pavyzdžiui: pirmas
        giminystės laipsnis – tarp tėvų ir vaikų, antrasis – tarp senolių ir jų
        vaikaičių, ir tarp brolių ir seserų ir t.t.
      </p>
      <p>
        Nepamirština, kad giminystei prilyginami santykiai tarp įvaikių ir jų
        palikuonių ir įtėvių bei jų giminaičių. Nors tokiu atveju kraujo ryšio
        nėra, tačiau, jeigu jau kas ryžtasi pripažinti kūdikį savo vaiku, tai
        privalės niekada nedaryti jokių skirtumų tarp biologinio vaiko ir
        įstatymiškai įvaikintojo…
      </p>
      <p>
        Giminystė kelia teisines pasekmes tik įstatymų numatytais atvejais ir
        tai, tik esant atitinkamam įstatymų numatytam giminystės artumo
        laipsniui. Pavyzdžiui, įstatymas nenumato paveldėjimo pagal įstatymą
        tarp antrosios eilės pusbrolių (pusseserių). Tarp jų leidžiama santuoka.
        Reiškia, šio laipsnio giminystė jau tik tradicinė ir įstatymiškai
        nelaikoma giminyste.
      </p>
      <p>
        Daugelyje teisės rūšių nurodoma, kad atitinkamos sąlygos atsiranda tarp
        artimųjų giminaičių. Reikėtų vadovautis LR CK 3.135 str., nurodančiu,
        kad&nbsp;<strong
          >artimaisiais giminaičiais pripažįstami tiesiosios linijos giminaičiai
          iki antrojo laipsnio imtinai</strong
        >
        (tėvai ir vaikai, seneliai ir vaikaičiai) ir šoninės linijos antrojo
        laipsnio giminaičiai (broliai ir seserys), jeigu ko nenumatyta
        specialiam atvejui arba specialioje normoje. Tačiau yra daug išimčių.
        Pvz., valstybė, nustatydama apmokestinimo tvarką, brolių ir seserų
        artimaisiais giminėmis nelaiko. Dovanojant turtą, nuo atitinkamų
        mokesčių atleidžiami tik tiesiosios žemutinės ir tiesiosios aukštutinės
        linijos giminaičiai, o broliai ir seserys – ne… Mat, kai valstybės
        „vyrams“ reikia pinigų – tada… brolis-lietuvis jau nebe brolis (lipk iš
        „grūšės“ ir mokėk…), o mokesčių mokėtojas.
      </p>
    </div>
  </div>
</template>
